import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroSection = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section
      className="hero-section"
      data-testid="hero-section"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1758691461935-202e2ef6b69f)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content container mx-auto px-4">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Comprehensive Adult Healthcare in Saginaw & Frankenmuth
          </h1>
          <p className="text-xl md:text-2xl text-gray-100 mb-8 leading-relaxed">
            Expert internal medicine care focused on prevention, chronic disease management,
            and lifelong wellness. Your partner in health.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              data-testid="hero-contact-btn"
              onClick={() => scrollTo('contact')}
              size="lg"
              className="text-white text-lg px-8 py-6"
              style={{ backgroundColor: 'var(--earth-accent)' }}
            >
              Contact Us
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              data-testid="hero-team-btn"
              onClick={() => scrollTo('providers')}
              size="lg"
              variant="outline"
              className="bg-white text-lg px-8 py-6 border-2 border-white"
              style={{ color: 'var(--sage-dark)' }}
            >
              Meet Our Team
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
